import { render, staticRenderFns } from "./OptionsGrid.vue?vue&type=template&id=34c848c9&scoped=true"
var script = {}
import style0 from "./OptionsGrid.vue?vue&type=style&index=0&id=34c848c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c848c9",
  null
  
)

export default component.exports